// extracted by mini-css-extract-plugin
export default {"validationOverview":"ValidationOverview_validationOverview__sq1FY","title":"ValidationOverview_title__o73co"};